import React from "react";
import PropTypes from "prop-types";
import DialogActions from "@mui/material/DialogActions";
import { MailProDialog } from "views/Pma/MailPro/components/MailProDialog/MailProDialog";
import { MailProDialogHeader } from "views/Pma/MailPro/components/MailProDialog/MailProDialogHeader";
import { MailProDialogBody } from "views/Pma/MailPro/components/MailProDialog/MailProDialogBody";

const TutorialDialogShell = ({
  open,
  onClose,
  hideHeader = false,
  title = "",
  headerStyle = {},
  actions = null,
  children = null,
  dialogProps = {},
  bodyClassName = "",
  bodyStyle = {},
}) => {
  return (
    <MailProDialog open={open} onClose={onClose} {...dialogProps}>
      {!hideHeader && <MailProDialogHeader style={headerStyle}>{title}</MailProDialogHeader>}
      <MailProDialogBody className={bodyClassName} style={bodyStyle}>
        {children}
      </MailProDialogBody>
      {actions ? (
        <DialogActions style={{ justifyContent: "center", paddingTop: "8px", paddingBottom: "16px" }}>
          {actions}
        </DialogActions>
      ) : null}
    </MailProDialog>
  );
};

TutorialDialogShell.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  hideHeader: PropTypes.bool,
  title: PropTypes.node,
  headerStyle: PropTypes.object,
  actions: PropTypes.node,
  children: PropTypes.node,
  dialogProps: PropTypes.object,
  bodyClassName: PropTypes.string,
  bodyStyle: PropTypes.object,
};

export default TutorialDialogShell;
